import { LinkedFieldWithLayoutSettings } from '@Components/LinkedFieldWithLayoutSettings';
import { serviceColumns } from '@Constants/TableColumns';
import { type ApiContainerType, type ApiService, EnumFrontendLayoutSetting } from '@Model';
import { FrameEditService } from '@Modules/Stammdaten';
import {
    type AsyncStateUpdate,
    Card,
    Grid,
    GridColumns,
    type IGuiBinder,
    useLinkedField,
    useLinkProperty,
    useTranslate,
} from '@synqo/frontend-component-library';
import { memo } from 'react';

// @ai-generated 2026-10-28T12:52:58+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5

interface IProps {
    binder: IGuiBinder<ApiContainerType>;
    baseApiObjectPath: string;
    requestUpdateState: AsyncStateUpdate<ApiContainerType>;
}

export const ContainerTypeBillingSection = memo(function ContainerTypeBillingSection({
    binder,
    baseApiObjectPath,
    requestUpdateState,
}: IProps) {
    const i18n = useTranslate('');

    const linkPlacementService = useLinkedField<ApiContainerType, ApiService>(
        baseApiObjectPath,
        'placement_service',
        FrameEditService,
        true,
        requestUpdateState,
    );
    const linkPickupService = useLinkedField<ApiContainerType, ApiService>(
        baseApiObjectPath,
        'pickup_service',
        FrameEditService,
        true,
        requestUpdateState,
    );
    const linkEmptyingService = useLinkedField<ApiContainerType, ApiService>(
        baseApiObjectPath,
        'emptying_service',
        FrameEditService,
        true,
        requestUpdateState,
    );
    const linkExchangeService = useLinkedField<ApiContainerType, ApiService>(
        baseApiObjectPath,
        'exchange_service',
        FrameEditService,
        true,
        requestUpdateState,
    );

    const placementServiceField = useLinkProperty(binder, linkPlacementService.linkApi);
    const pickupServiceField = useLinkProperty(binder, linkPickupService.linkApi);
    const emptyingServiceField = useLinkProperty(binder, linkEmptyingService.linkApi);
    const exchangeServiceField = useLinkProperty(binder, linkExchangeService.linkApi);

    return (
        <Card name="billing" label="Abrechnung">
            <Grid>
                <GridColumns spans={[6, 6]}>
                    <LinkedFieldWithLayoutSettings<ApiService>
                        layoutSettingsContext={EnumFrontendLayoutSetting.ServicesTableLayout}
                        {...placementServiceField}
                        {...linkPlacementService.events}
                        columns={serviceColumns}
                        label={i18n('Leistung Stellung')}
                    />
                    <LinkedFieldWithLayoutSettings<ApiService>
                        layoutSettingsContext={EnumFrontendLayoutSetting.ServicesTableLayout}
                        {...pickupServiceField}
                        {...linkPickupService.events}
                        columns={serviceColumns}
                        label={i18n('Leistung Abholung')}
                    />
                </GridColumns>
                <GridColumns spans={[6, 6]}>
                    <LinkedFieldWithLayoutSettings<ApiService>
                        layoutSettingsContext={EnumFrontendLayoutSetting.ServicesTableLayout}
                        {...emptyingServiceField}
                        {...linkEmptyingService.events}
                        columns={serviceColumns}
                        label={i18n('Leistung Leerung')}
                    />
                    <LinkedFieldWithLayoutSettings<ApiService>
                        layoutSettingsContext={EnumFrontendLayoutSetting.ServicesTableLayout}
                        {...exchangeServiceField}
                        {...linkExchangeService.events}
                        columns={serviceColumns}
                        label={i18n('Leistung Tausch')}
                    />
                </GridColumns>
            </Grid>
        </Card>
    );
});
